import { useEffect, useState } from 'react';
import { chromeIntentUrl, detectBrowserInfo } from '../lib/browserInfo';

const DISMISS_KEY = 'fbc.samsungBanner.dismissed';

/**
 * Non-blocking hint for Samsung Internet during LAN HTTP development.
 * Never requires Chrome — Continue / Dismiss always available.
 */
export function SamsungInternetBanner(): JSX.Element | null {
  const [visible, setVisible] = useState(false);
  const [chromeUrl, setChromeUrl] = useState<string | null>(null);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(DISMISS_KEY) === '1') return;
    } catch {
      /* private mode */
    }
    const info = detectBrowserInfo();
    if (!info.isSamsungInternet) return;
    setVisible(true);
    setChromeUrl(chromeIntentUrl());
  }, []);

  if (!visible || !import.meta.env.DEV) return null;

  const dismiss = (): void => {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  return (
    <div className="samsung-banner" role="status">
      <p className="mt-0">
        For the best development experience, Chrome generally provides more
        consistent support for modern web APIs.
      </p>
      <div className="row" style={{ flexWrap: 'wrap', gap: '0.5rem' }}>
        <button type="button" className="btn btn-primary" onClick={dismiss}>
          Continue in Samsung Internet
        </button>
        {chromeUrl && (
          <a className="btn" href={chromeUrl}>
            Open in Chrome
          </a>
        )}
        <button type="button" className="btn" onClick={dismiss}>
          Dismiss
        </button>
      </div>
    </div>
  );
}
